import * as yup from 'yup';

const nameRegexp = /^([a-zA-Z]{0,30})$/;
const phoneRegexp = /(?:\+|\d)[\d\-\(\) ]{9,}\d/g;
const emailRegexp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const formSchema = yup.object().shape({
  name: yup.string().matches(nameRegexp, 'Incorrect name').required('Required field'),
  phone: yup.string().matches(phoneRegexp, 'Incorrect phone number').required('Required field'),
  email: yup.string().matches(emailRegexp, 'Incorrect email').required('Required field'),
});
